import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  trackPulseClick,
} from './pulseClickIds';
import { PULSE_VIEW_ID, resolvePhase1RouteViewId } from './pulseViewIds';

/** Cancel Order CTA — view_id is the live page or modal (thank_you, order_tracking_modal, …). */
export const trackCancelOrderClick = ({
  order_id,
  page_path,
  view_id,
}: {
  order_id: string | number;
  page_path?: string;
  view_id?: string;
}): void => {
  const path =
    page_path !== undefined
      ? page_path
      : typeof window !== 'undefined'
        ? window.location.pathname
        : undefined;
  const resolvedViewId =
    view_id ??
    (path ? resolvePhase1RouteViewId(path) : null) ??
    PULSE_VIEW_ID.THANK_YOU;

  trackPulseClick({
    category: PULSE_CLICK_CATEGORY.ORDER_MANAGEMENT,
    action: PULSE_CLICK_ACTION.TAP_CANCEL_ORDER,
    label: null,
    view_id: resolvedViewId,
    page_id: PULSE_CLICK_CATEGORY.ORDER_MANAGEMENT,
    page_path: path,
    additional_params: { order_id },
  });
};
